<div class="static-page" [innerHTML]="content"></div>
